import { useState } from 'react'

import copy from '../../demo/fixtures/w5/copy.json'
import { useDemoStore } from '../../demo/store'
import { Button, Card, CardHead, Icon, Toast, ToastHost } from '../../ui'
import { ProcessSteps } from '../analysis/ProcessSteps'
import { fillTemplate, useW5Live, type W5Live } from '../analysis/live'
import { useProcessRun } from '../analysis/useProcessRun'
import styles from './AutomationPage.module.css'

export function RuleGroups() {
  const { automation } = useW5Live()
  const setAutoRule = useDemoStore((state) => state.setAutoRule)
  const [toast, setToast] = useState<string | null>(null)
  const { visibleSteps, running, run } = useProcessRun()

  const toggle = async (item: W5Live['automation']['rules'][number]) => {
    if (running || item.locked) return
    const nextOn = !item.on
    setAutoRule(item.key, nextOn)
    const vars = { key: item.key, name: item.name, cond: item.cond, action: item.action, scope: item.scope, weekRuns: item.weekRuns }
    const templates = nextOn ? copy.process.autoRuleOn : copy.process.autoRuleOff
    const completed = await run(templates.map((step) => ({ label: fillTemplate(step.label, vars), detail: fillTemplate(step.detail, vars) })), copy.process)
    if (!completed) return
    setToast(nextOn
      ? `已开启 ${item.key} ${item.name}，明天 09:00 起按「${item.cond}」执行`
      : `已关闭 ${item.key} ${item.name}，明天 09:00 起不再执行（本周它触发过 ${item.weekRuns} 次）`)
  }

  return (
    <Card className={`${styles.section} ${styles.ruleCard}`} data-scope="rule-groups" lang="zh-CN">
      <CardHead title={copy.sections.rules} subtitle={`${automation.enabledRules} 条启用 · 共 ${automation.rules.length} 条 · 按目的分组 · 每天 09:00 检查`} />
      {automation.groupOrder.map((purpose) => (
        <section className={styles.ruleGroup} key={purpose}>
          <h3 className={styles.groupTitle}>{purpose}</h3>
          {automation.rules.filter((item) => item.purpose === purpose).map((item) => (
            <div className={styles.ruleRow} key={item.key}>
              <div className={styles.ruleDescription}>
                <p className={styles.ruleName}>{item.name}<span className={styles.ruleKey}>{item.key}</span>{item.needsConfirm ? <span className={`${styles.statusChip} ${styles.lockChip}`}><Icon name="lock" size={12} strokeWidth={2} />需人工确认</span> : null}</p>
                <p className={styles.condition}>当 {item.cond} → {item.action}{' '}<span className={styles.scope}>· {item.scope}{'createdAt' in item ? ` · 新建于 ${item.createdAt}` : ''}</span></p>
              </div>
              <span className={styles.weekRuns}><i style={{ width: `${Math.max(6, item.weekRuns * 22)}px` }} />{item.weekRuns} 次</span>
              {item.locked ? <span className={`${styles.statusChip} ${styles.lockChip}`}><Icon name="shield" size={12} strokeWidth={2} />始终开启</span> : <Button role="switch" aria-checked={item.on} aria-label={`${item.key} ${item.on ? '已开启' : '已关闭'}`} className={`${styles.switchButton} ${item.on ? styles.switchOn : ''}`} disabled={running} variant="ghost" onClick={() => void toggle(item)}><i /></Button>}
            </div>
          ))}
        </section>
      ))}
      {running ? <div className={styles.processSlot}><ProcessSteps steps={visibleSteps} /></div> : null}
      {toast ? <ToastHost inline><Toast onDismiss={() => setToast(null)}>{toast}</Toast></ToastHost> : null}
    </Card>
  )
}
